<section class="page">
  <header class="page__header" aria-hidden="true"></header>

  <div class="modal" *ngIf="errorMessage" role="alertdialog" aria-live="assertive">
    <div class="modal__backdrop"></div>
    <div class="modal__dialog">
      <h3>Fehler beim Speichern</h3>
      <p>{{ errorMessage }}</p>
      <button type="button" class="primary" (click)="closeError()">OK</button>
    </div>
  </div>

  <div class="modal" *ngIf="confirmMessage" role="dialog" aria-live="polite">
    <div class="modal__backdrop"></div>
    <div class="modal__dialog">
      <h3>Bestätigung</h3>
      <p>{{ confirmMessage }}</p>
      <div class="modal__actions">
        <button type="button" class="secondary" (click)="closeConfirm()">Abbrechen</button>
        <button type="button" class="primary" (click)="confirmProceed()">OK</button>
      </div>
    </div>
  </div>

  <div class="modal" *ngIf="warningMessage" role="alertdialog" aria-live="assertive">
    <div class="modal__backdrop"></div>
    <div class="modal__dialog">
      <h3>Hinweis</h3>
      <p>{{ warningMessage }}</p>
      <button type="button" class="primary" (click)="closeWarning()">OK</button>
    </div>
  </div>

  <div
    class="comment-popup"
    *ngIf="commentTooltipText"
    [style.left.px]="commentTooltipX"
    [style.top.px]="commentTooltipY"
    role="tooltip"
  >
    {{ commentTooltipText }}
  </div>

  <div class="evaluation-modal" *ngIf="evaluationEntry as entry" role="dialog" aria-modal="true">
    <div class="evaluation-modal__backdrop" (click)="closeEvaluationDialog()"></div>
    <div class="evaluation-modal__content">
      <header class="evaluation-modal__header">
        <div>
          <h3>Auswertungsjournal: {{ entry.symbol }}</h3>
          <p>{{ entry.entryDate || '-' }} bis {{ entry.sellDate || '-' }}</p>
        </div>
        <button type="button" class="neutral icon" (click)="closeEvaluationDialog()" aria-label="Schließen">✖</button>
      </header>

      <section class="evaluation-modal__summary">
        <div>
          <span>Kauf</span>
          <strong>{{ entry.entryPrice | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</strong>
          <small>{{ entry.entryDate || '-' }} · {{ entry.size }} Stk.</small>
        </div>
        <div>
          <span>Verkauf</span>
          <strong>{{ (averageSellPrice(entry) ?? 0) | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</strong>
          <small>{{ entry.sellDate || '-' }}</small>
        </div>
        <div>
          <span>R</span>
          <strong [ngClass]="pnlClass(displayR(entry))">{{ displayR(entry) | number:'1.2-2' }}R</strong>
          <small>Realisiertes Ergebnis</small>
        </div>
        <div>
          <span>G&V</span>
          <strong [ngClass]="pnlClass(displayPnl(entry))">{{ displayPnl(entry) | number:'1.2-2' }} €</strong>
          <small>Nach Gebühren</small>
        </div>
      </section>

      <div class="evaluation-modal__grid">
        <section class="evaluation-modal__panel">
          <h4>Kommentar</h4>
          <textarea rows="12" [(ngModel)]="evaluationComment"></textarea>
          <div class="evaluation-append">
            <label>
              Weitere URL
              <input
                type="url"
                [(ngModel)]="evaluationMediaUrl"
                [ngModelOptions]="{standalone: true}"
                placeholder="https://..."
                (input)="clearEvaluationMediaUpload()"
              />
            </label>
            <label>
              Weiteres Bild
              <div
                class="evaluation-dropzone"
                role="button"
                tabindex="0"
                (dragover)="onEvaluationMediaDragOver($event)"
                (dragleave)="onEvaluationMediaDragLeave($event)"
                (drop)="handleEvaluationMediaDrop($event)"
                (click)="evaluationMediaInput?.click()"
                (keydown.enter)="$event.preventDefault(); evaluationMediaInput?.click()"
                (keydown.space)="$event.preventDefault(); evaluationMediaInput?.click()"
                (paste)="handleEvaluationMediaPaste($event)"
                [class.evaluation-dropzone--active]="evaluationMediaDropActive"
                aria-label="Bild hier ablegen, auswählen oder einfügen"
              >
                <input
                  type="file"
                  accept="image/*"
                  #evaluationMediaInput
                  class="visually-hidden"
                  (change)="handleEvaluationMediaFileSelection($event)"
                  aria-hidden="true"
                  tabindex="-1"
                />
                <span>Bild hierher ziehen, klicken oder per Strg+V einfügen.</span>
                <small *ngIf="evaluationMediaUploadName">Ausgewählt: {{ evaluationMediaUploadName }}</small>
                <small class="error-text" *ngIf="evaluationMediaUploadError">{{ evaluationMediaUploadError }}</small>
              </div>
            </label>
          </div>
          <div class="evaluation-modal__actions">
            <button type="button" class="primary" (click)="saveEvaluationDetails(entry)">Speichern</button>
            <button type="button" class="neutral" (click)="closeEvaluationDialog()">Schließen</button>
          </div>
        </section>

        <section class="evaluation-modal__panel evaluation-modal__preview">
          <h4>Bilder / Links</h4>
          <div class="evaluation-media" *ngIf="evaluationMediaTabs(entry).length; else noEvaluationTarget">
            <div class="evaluation-media__tabs" role="tablist" aria-label="Auswertungsmedien">
              <button
                type="button"
                class="evaluation-media__tab"
                *ngFor="let tab of evaluationMediaTabs(entry)"
                [class.evaluation-media__tab--active]="activeEvaluationMediaId === tab.id"
                (click)="setActiveEvaluationMedia(tab.id)"
              >
                {{ tab.label }}
              </button>
            </div>
            <div class="evaluation-media__body" *ngIf="activeEvaluationMedia(entry) as media">
              <figure class="evaluation-media__image" *ngIf="media.type === 'image'">
                <img [src]="media.url" [alt]="media.label" />
                <figcaption>{{ media.label }}</figcaption>
              </figure>
              <div class="evaluation-media__link" *ngIf="media.type === 'link'">
                <div>
                  <span>{{ media.label }}</span>
                  <strong>{{ media.url }}</strong>
                </div>
                <a [href]="media.url" target="_blank" rel="noopener noreferrer">In neuem Tab öffnen</a>
            </div>
            </div>
          </div>
          <ng-template #noEvaluationTarget>
            <div class="evaluation-modal__empty">Kein Verkaufslink oder Screenshot hinterlegt.</div>
          </ng-template>
        </section>
      </div>
    </div>
  </div>

  <app-analysis-dialog
    *ngIf="analysisDialogOpen && analysisData"
    [analysisData]="analysisData"
    [showApply]="true"
    (close)="closeAnalysisDialog()"
    (applyVariant)="applyAnalysisVariant($event)"
  ></app-analysis-dialog>

  <div class="setup-detail-modal" *ngIf="setupDetailText as text" role="dialog" aria-modal="true">
    <div class="setup-detail-modal__backdrop" (click)="closeSetupDetails()"></div>
    <div class="setup-detail-modal__content">
      <header class="setup-detail-modal__header">
        <div>
          <h2>{{ text.bezeichnung }}</h2>
          <p>{{ text.feldTextId }}</p>
        </div>
        <button type="button" class="secondary" (click)="closeSetupDetails()" aria-label="Schließen">Schließen</button>
      </header>
      <section class="setup-detail-modal__description">
        <h3>Beschreibung</h3>
        <p *ngIf="text.beschreibung?.trim(); else noSetupDescription">{{ text.beschreibung }}</p>
        <ng-template #noSetupDescription><p class="empty">Keine Beschreibung hinterlegt.</p></ng-template>
      </section>
      <section class="setup-detail-modal__gallery">
        <h3>Medien</h3>
        <div class="setup-media-tabs" *ngIf="setupDetailTabs().length; else noSetupMedia">
          <div class="setup-media-tabs__nav" role="tablist" aria-label="Setup-Medien">
            <button
              type="button"
              class="setup-media-tabs__tab"
              *ngFor="let tab of setupDetailTabs()"
              [class.setup-media-tabs__tab--active]="activeSetupDetailTabId === tab.id"
              (click)="setActiveSetupDetailTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
          <div class="setup-media-tabs__body" *ngIf="activeSetupDetailTab() as tab">
            <figure class="setup-media-preview" *ngIf="tab.type === 'image' && tab.image">
              <img [src]="tab.image.imageDataUrl" [alt]="tab.image.name" />
              <figcaption>{{ tab.image.name }}</figcaption>
            </figure>
            <div class="setup-link-preview" *ngIf="tab.type === 'links'">
              <a *ngFor="let link of setupDetailLinks()" [href]="link.url" target="_blank" rel="noopener noreferrer">
                {{ link.label }}
              </a>
            </div>
          </div>
        </div>
        <ng-template #noSetupMedia><p class="empty">Keine Bilder oder Links hinterlegt.</p></ng-template>
      </section>
    </div>
  </div>

  <div class="journal-tabs" role="tablist" aria-label="Tagebuchbereiche">
    <button
      *ngFor="let area of journalAreas"
      type="button"
      class="journal-tabs__tab"
      [class.active]="activeJournalArea?.feldTextId === area.feldTextId"
      [attr.aria-selected]="activeJournalArea?.feldTextId === area.feldTextId"
      role="tab"
      (click)="setActiveJournalArea(area)"
    >
      {{ area.bezeichnung }}
    </button>
  </div>

  <form [formGroup]="tradeForm" (ngSubmit)="addTrade()" class="card grid">
    <div class="journal-area-title">Bereich: <strong>{{ activeJournalArea?.bezeichnung }}</strong></div>
    <div class="collapsible card--subtle" aria-label="Risikosteuerung">
      <div class="collapsible__header">
        <div>
          <div class="collapsible__title">Risiko &amp; Währung</div>
          <div class="collapsible__subtitle">Steuere dein Risiko und Budget.</div>
        </div>
        <button type="button" class="secondary icon icon--pill" (click)="toggleRiskPanel()" [attr.aria-expanded]="!riskPanelCollapsed">
          {{ riskPanelCollapsed ? '▼' : '▲' }}
        </button>
      </div>
      <div *ngIf="!riskPanelCollapsed" class="collapsible__content">
        <div class="risk-bar" aria-label="Risikosteuerung">
          <div class="risk-bar__stats">
            <div *ngIf="showFinancialColumns">Positions-G&V (EUR): <strong class="numeric">{{ positionedPnLEuro | number:'1.0-2' }} €</strong></div>
            <div>Gesamt-Risikobudget: <strong class="numeric">{{ totalRiskBudgetEuro | number:'1.0-2' }} €</strong></div>
            <div>Risiko pro Trade: <strong class="numeric">{{ riskPerTradeEuro | number:'1.0-2' }} €</strong></div>
            <div>Risiko pro Stück: <strong class="numeric">{{ riskPerShare() | number:'1.2-2' }} €</strong></div>
            <div>Mögliche Stückzahl: <strong class="numeric">{{ maxPositionSize() }}</strong></div>
            <div *ngIf="appliedRiskStep" class="risk-bar__status">Stufe: ab {{ appliedRiskStep.profitMinEUR }} → {{ appliedRiskStep.riskPerTradeEUR }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="collapsible card--subtle" *ngIf="showAiAndJsonInputs" aria-label="ChatGPT">
      <div class="collapsible__header">
        <div>
          <div class="collapsible__title">ChatGPT</div>
          <div class="collapsible__subtitle">Freitext auswerten und Prompts verwalten.</div>
        </div>
        <button type="button" class="secondary icon icon--pill" (click)="toggleChatPanel()" [attr.aria-expanded]="!chatPanelCollapsed">
          {{ chatPanelCollapsed ? '▼' : '▲' }}
        </button>
      </div>
      <div *ngIf="!chatPanelCollapsed" class="collapsible__content">
        <div class="ai-helper card--subtle" aria-label="Trade-Automatisierung">
          <label class="wide">
            Gespeicherte Prompts
            <select [(ngModel)]="selectedPromptId" [ngModelOptions]="{standalone: true}" (ngModelChange)="selectPrompt($event)">
              <option *ngFor="let prompt of aiPrompts" [ngValue]="prompt.id">{{ prompt.name }}</option>
            </select>
          </label>
          <label class="wide ai-helper__input">
            Freitext für ChatGPT-Auswertung
            <textarea rows="2" formControlName="aiPrompt" placeholder="z. B. Long Trend Entry 22.5 Stop 21.8 Ziel 25"></textarea>
          </label>
          <div class="ai-helper__actions">
            <button type="button" class="secondary" (click)="applyAiPrompt()">Text auswerten</button>
            <button type="button" class="secondary prompt-button" (click)="togglePromptPanel()" [attr.aria-expanded]="promptPanelVisible">
              Prompt
            </button>
            <span class="ai-helper__status">{{ aiStatus }}</span>
          </div>
          <div class="ai-helper__prompt" *ngIf="promptPanelVisible">
            <div class="prompt-grid">
              <label>
                Neuer Prompt-Name
                <input type="text" [(ngModel)]="newPromptName" [ngModelOptions]="{standalone: true}" placeholder="z. B. Breakout" />
              </label>
              <label>
                Gewählten Prompt bearbeiten
                <select [(ngModel)]="selectedPromptId" [ngModelOptions]="{standalone: true}" (ngModelChange)="choosePromptForEdit($event)">
                  <option [ngValue]="null">Bitte wählen</option>
                  <option *ngFor="let prompt of aiPrompts" [ngValue]="prompt.id">{{ prompt.name }}</option>
                </select>
              </label>
              <label>
                Name aktualisieren
                <input type="text" [(ngModel)]="editPromptName" [ngModelOptions]="{standalone: true}" placeholder="Name aktualisieren" />
              </label>
            </div>
            <label class="wide">
              Prompt für ChatGPT (Anweisungen)
              <textarea rows="3" formControlName="aiSystemPrompt" placeholder="Instruktionen für die Extraktion (wird gespeichert)"></textarea>
            </label>
            <div class="prompt-actions">
              <button type="button" class="primary" (click)="savePrompt()">Prompt speichern</button>
              <button type="button" class="secondary" (click)="updatePrompt()" [disabled]="!selectedPromptId">Prompt aktualisieren</button>
              <button type="button" class="secondary danger" (click)="deletePrompt()" [disabled]="!selectedPromptId">Prompt löschen</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="collapsible card--subtle" aria-label="Neue Werte erfassen">
      <div class="collapsible__header">
        <div>
          <div class="collapsible__title">Neue Werte erfassen</div>
          <div class="collapsible__subtitle">Formularfelder ein- oder ausblenden.</div>
        </div>
        <button type="button" class="secondary icon icon--pill" (click)="toggleEntryPanel()" [attr.aria-expanded]="!entryPanelCollapsed">
          {{ entryPanelCollapsed ? '▼' : '▲' }}
        </button>
      </div>
      <div *ngIf="!entryPanelCollapsed" class="collapsible__content grid--fields">
        <div class="analysis-import" *ngIf="showAiAndJsonInputs">
          <div class="analysis-import__drops">
            <div
              class="analysis-dropzone"
              role="button"
              tabindex="0"
              (dragover)="onAnalysisDragOver($event)"
              (dragleave)="onAnalysisDragLeave($event)"
              (drop)="handleAnalysisDrop($event)"
              (click)="analysisFileInput?.click()"
              (keydown.enter)="$event.preventDefault(); analysisFileInput?.click()"
              (keydown.space)="$event.preventDefault(); analysisFileInput?.click()"
              [class.analysis-dropzone--active]="analysisDropActive"
              aria-label="Analyse JSON hier ablegen oder auswaehlen"
            >
              <input
                type="file"
                accept="application/json,.json"
                #analysisFileInput
                class="visually-hidden"
                (change)="handleAnalysisFileSelection($event)"
                aria-hidden="true"
                tabindex="-1"
              />
              <div class="analysis-dropzone__label">Analyse-JSON hierher ziehen oder klicken.</div>
              <div class="analysis-dropzone__status" *ngIf="analysisFileName">Geladen: {{ analysisFileName }}</div>
              <div class="analysis-dropzone__status" *ngIf="analysisPersistedId">In Datenbank gespeichert</div>
            </div>
            <div
              class="analysis-dropzone"
              role="button"
              tabindex="0"
              (dragover)="onAnalysisImageDragOver($event)"
              (dragleave)="onAnalysisImageDragLeave($event)"
              (drop)="handleAnalysisImageDrop($event)"
              (paste)="handleAnalysisImagePaste($event)"
              (click)="analysisImageInput?.click()"
              (keydown.enter)="$event.preventDefault(); analysisImageInput?.click()"
              (keydown.space)="$event.preventDefault(); analysisImageInput?.click()"
              [class.analysis-dropzone--active]="analysisImageDropActive"
              aria-label="TradingView Bild hier ablegen oder auswaehlen"
            >
              <input
                type="file"
                accept="image/png,image/jpeg,image/webp,image/gif"
                #analysisImageInput
                class="visually-hidden"
                (change)="handleAnalysisImageFileSelection($event)"
                aria-hidden="true"
                tabindex="-1"
              />
              <div class="analysis-dropzone__label">TradingView-Bild hierher ziehen, klicken oder einfuegen.</div>
              <div class="analysis-dropzone__status" *ngIf="analysisImageUploadName && !analysisImageRunning">Geladen: {{ analysisImageUploadName }}</div>
              <div class="analysis-dropzone__status" *ngIf="analysisImageRunning">OpenAI analysiert das Bild...</div>
            </div>
          </div>
          <div class="analysis-dropzone__error" *ngIf="analysisUploadError">{{ analysisUploadError }}</div>
          <button
            type="button"
            class="secondary analysis-open"
            *ngIf="hasAnalysisVariants(analysisData)"
            (click)="openAnalysisDialog()"
          >
            Aktuelle Analyse wieder anzeigen
          </button>
        </div>

        <label>
          Typ
          <select formControlName="tradeType" (change)="onTradeTypeChange()">
            <option value="CFD">CFD</option>
            <option value="Aktie">Aktie</option>
            <option value="Zertifikat">Zertifikat</option>
          </select>
        </label>
        <label>
          {{ isCfdSelected() ? 'CFD-Wert' : 'Kürzel' }}
          <select *ngIf="isCfdSelected(); else symbolInput" formControlName="symbol" (change)="onCfdValueChange()" required>
            <option value="" disabled>CFD auswählen</option>
            <option *ngFor="let cfd of cfdDetails" [value]="cfd.bezeichnung">{{ cfd.bezeichnung }}</option>
          </select>
          <ng-template #symbolInput>
            <input type="text" formControlName="symbol" required />
          </ng-template>
        </label>
        <label>
          Positioniert
          <select formControlName="positioned">
            <option [ngValue]="true">Ja</option>
            <option [ngValue]="false">Nein</option>
          </select>
        </label>
        <label>
          Datum des Einstiegs
          <input type="date" formControlName="entryDate" />
        </label>
        <label>
          Long / Short
          <select formControlName="direction" (change)="recalculatePositionAndProfit('direction')">
            <option value="Long">Long</option>
            <option value="Short">Short</option>
          </select>
        </label>
        <label>
          <span class="label-with-info">
            Setup
            <button
              type="button"
              class="info-icon info-icon--button"
              (click)="openSetupDetails()"
              [disabled]="!hasSetupDetails()"
              title="Setup-Details anzeigen"
              aria-label="Setup-Details anzeigen"
            >i</button>
          </span>
          <select formControlName="setup" (change)="onSetupSelectionChange()">
            <option *ngFor="let setup of setups" [value]="setup">{{ setup }}</option>
          </select>
        </label>
        <label>
          Währung
          <select formControlName="currency">
            <option *ngFor="let currency of currencies" [value]="currency">{{ currency }}</option>
          </select>
        </label>
        <div class="price-row">
          <label>
            Entry Kurs
            <input type="number" formControlName="entryPrice" step="0.01" (blur)="recalculatePositionAndProfit('entry')" />
          </label>
          <label>
            Stop Kurs
            <input type="number" formControlName="stopPrice" step="0.01" [readonly]="isCfdSelected()" (blur)="recalculatePositionAndProfit('stop')" />
            <small *ngIf="isCfdSelected()">Automatisch aus Entry, Take Profit und CRV</small>
          </label>
          <label>
            {{ isCfdSelected() ? 'Take Profit' : 'Ziel Kurs' }}
            <input type="number" formControlName="targetPrice" step="0.01" (blur)="onCfdTargetChange()" />
            <small *ngIf="!isCfdSelected()">Berechnet (Chance/Risiko): {{ targetPricePreview() | number:'1.2-2' }} €</small>
          </label>
          <label>
            Stückzahl
            <input type="number" formControlName="size" step="1" [readonly]="isCfdSelected()" (blur)="handleSizeBlur()" />
            <small>{{ isCfdSelected() ? 'Automatisch aus Risikobudget, Marge und Stop berechnet' : 'Automatisch aus Risiko (€) und Entry/Stop berechnet, aber editierbar' }}</small>
          </label>
          <label>
            Gebühren (Kauf, €)
            <input type="number" formControlName="entryFee" step="0.01" min="0" (input)="markCfdEntryFeeManual()" />
            <small *ngIf="isCfdSelected()">Automatisch vorbelegt, aber jederzeit manuell änderbar</small>
          </label>
        </div>
        <div class="metrics">
          <div>Risiko pro Stück: <strong class="numeric">{{ riskPerShare() | number:'1.2-2' }} €</strong></div>
          <div>Mögliche Stückzahl mit Budget: <strong class="numeric">{{ maxPositionSize() }}</strong></div>
          <div>Möglicher Verlust: <strong class="numeric">{{ potentialLoss() | number:'1.0-2' }} €</strong></div>
          <div>Möglicher Gewinn bei Ziel: <strong class="numeric">{{ potentialProfit() | number:'1.0-2' }} €</strong></div>
          <div>
            CRV:
            <strong
              class="numeric"
              [ngClass]="{ 'risk-low': riskRewardPreview() > 0 && riskRewardPreview() < 2 }"
            >
              {{ riskRewardPreview() | number:'1.2-2' }}
            </strong>
          </div>
        </div>
        <div class="questionnaire">
          <section class="questionnaire__section">
            <button
              type="button"
              class="questionnaire__toggle"
              (click)="toggleQuestionPanel('setup')"
              [attr.aria-expanded]="!setupQuestionsCollapsed"
            >
              <span>Setup Fragen</span>
              <span aria-hidden="true">{{ setupQuestionsCollapsed ? '+' : '-' }}</span>
            </button>
            <div class="questionnaire__block" *ngIf="!setupQuestionsCollapsed">
            <div class="questionnaire__item">
              <div class="questionnaire__question">{{ questionText('questionHigherTimeframe') }}</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionHigherTimeframe')?.value === true"
                    (change)="setQuestionValue('questionHigherTimeframe', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionHigherTimeframe')?.value === false"
                    (change)="setQuestionValue('questionHigherTimeframe', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item">
              <div class="questionnaire__question">{{ questionText('questionHigherTimeframeConfirmsTrend') }}</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionHigherTimeframeConfirmsTrend')?.value === true"
                    (change)="setQuestionValue('questionHigherTimeframeConfirmsTrend', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionHigherTimeframeConfirmsTrend')?.value === false"
                    (change)="setQuestionValue('questionHigherTimeframeConfirmsTrend', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item">
              <div class="questionnaire__question">{{ questionText('questionSupportResistance') }}</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionSupportResistance')?.value === true"
                    (change)="setQuestionValue('questionSupportResistance', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionSupportResistance')?.value === false"
                    (change)="setQuestionValue('questionSupportResistance', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item">
              <div class="questionnaire__question">{{ questionText('questionEma200') }}</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionEma200')?.value === true"
                    (change)="setQuestionValue('questionEma200', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionEma200')?.value === false"
                    (change)="setQuestionValue('questionEma200', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item">
              <div class="questionnaire__question">{{ questionText('questionEarningsSoon') }}</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionEarningsSoon')?.value === true"
                    (change)="setQuestionValue('questionEarningsSoon', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionEarningsSoon')?.value === false"
                    (change)="setQuestionValue('questionEarningsSoon', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item">
              <div class="questionnaire__question">Kann ich in 3 sec. ja zu meinem Setup und dem Chart sagen?</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionSetupConfidence')?.value === true"
                    (change)="setQuestionValue('questionSetupConfidence', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionSetupConfidence')?.value === false"
                    (change)="setQuestionValue('questionSetupConfidence', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            </div>
          </section>
          <section class="questionnaire__section">
            <button
              type="button"
              class="questionnaire__toggle"
              (click)="toggleQuestionPanel('emotion')"
              [attr.aria-expanded]="!emotionQuestionsCollapsed"
            >
              <span>Emotionen</span>
              <span aria-hidden="true">{{ emotionQuestionsCollapsed ? '+' : '-' }}</span>
            </button>
            <div class="questionnaire__block" *ngIf="!emotionQuestionsCollapsed">
            <div class="questionnaire__item" *ngIf="!isLongTermArea()">
              <div class="questionnaire__question">
                Mache ich den Trade um Geld zu verdienen oder Weil mein Ego das will?
              </div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionMotivation')?.value === true"
                    (change)="setQuestionValue('questionMotivation', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionMotivation')?.value === false"
                    (change)="setQuestionValue('questionMotivation', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item">
              <div class="questionnaire__question">Emmotional bin ich drauf:</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionEmotionalState')?.value === 'gut'"
                    (change)="setQuestionChoice('questionEmotionalState', 'gut')"
                  />
                  gut
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionEmotionalState')?.value === 'geht so'"
                    (change)="setQuestionChoice('questionEmotionalState', 'geht so')"
                  />
                  geht so
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionEmotionalState')?.value === 'schlecht'"
                    (change)="setQuestionChoice('questionEmotionalState', 'schlecht')"
                  />
                  schlecht
                </label>
              </div>
            </div>
            <div class="questionnaire__item" *ngIf="!isLongTermArea()">
              <div class="questionnaire__question">
                Risk Management check. Ist meine Entscheidung auf Struktur begründet? Oder Angst? Ist dein Stop
                optimal oder zu optimistisch?
              </div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionRiskManagement')?.value === true"
                    (change)="setQuestionValue('questionRiskManagement', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionRiskManagement')?.value === false"
                    (change)="setQuestionValue('questionRiskManagement', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item" *ngIf="!isLongTermArea()">
              <div class="questionnaire__question">War einer der letzten drei Trades positiv?</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionLastTradesPositive')?.value === true"
                    (change)="setQuestionValue('questionLastTradesPositive', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionLastTradesPositive')?.value === false"
                    (change)="setQuestionValue('questionLastTradesPositive', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item" *ngIf="!isLongTermArea() && tradeForm.get('questionLastTradesPositive')?.value === false">
              <div class="questionnaire__question">Habe ich mir die drei Trades nochmal angeschaut?</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionReviewedLastTrades')?.value === true"
                    (change)="setQuestionValue('questionReviewedLastTrades', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionReviewedLastTrades')?.value === false"
                    (change)="setQuestionValue('questionReviewedLastTrades', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item" *ngIf="isLongTermArea()">
              <div class="questionnaire__question">{{ questionText('questionRecommendedStock') }}</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionRecommendedStock')?.value === true"
                    (change)="setQuestionValue('questionRecommendedStock', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionRecommendedStock')?.value === false"
                    (change)="setQuestionValue('questionRecommendedStock', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item" *ngIf="isLongTermArea()">
              <div class="questionnaire__question">{{ questionText('questionHighlySpeculative') }}</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionHighlySpeculative')?.value === true"
                    (change)="setQuestionValue('questionHighlySpeculative', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionHighlySpeculative')?.value === false"
                    (change)="setQuestionValue('questionHighlySpeculative', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item" *ngIf="isLongTermArea()">
              <div class="questionnaire__question">{{ questionText('questionLowVolumeMoves') }}</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionLowVolumeMoves')?.value === true"
                    (change)="setQuestionValue('questionLowVolumeMoves', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionLowVolumeMoves')?.value === false"
                    (change)="setQuestionValue('questionLowVolumeMoves', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            </div>
          </section>
          <section class="questionnaire__section">
            <button
              type="button"
              class="questionnaire__toggle"
              (click)="toggleQuestionPanel('technical')"
              [attr.aria-expanded]="!technicalQuestionsCollapsed"
            >
              <span>Technische Fragen</span>
              <span aria-hidden="true">{{ technicalQuestionsCollapsed ? '+' : '-' }}</span>
            </button>
            <div class="questionnaire__block" *ngIf="!technicalQuestionsCollapsed">
            <div class="questionnaire__item" *ngIf="!isLongTermArea()">
              <div class="questionnaire__question">{{ questionText('questionRsiUnder60') }}</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionRsiUnder60')?.value === true"
                    (change)="setQuestionValue('questionRsiUnder60', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionRsiUnder60')?.value === false"
                    (change)="setQuestionValue('questionRsiUnder60', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item" *ngIf="isLongTermArea()">
              <div class="questionnaire__question">{{ questionText('questionRsiOverbought') }}</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionRsiOverbought')?.value === true"
                    (change)="setQuestionValue('questionRsiOverbought', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionRsiOverbought')?.value === false"
                    (change)="setQuestionValue('questionRsiOverbought', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item">
              <div class="questionnaire__question">{{ questionText('questionTrendClear') }}</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionTrendClear')?.value === true"
                    (change)="setQuestionValue('questionTrendClear', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionTrendClear')?.value === false"
                    (change)="setQuestionValue('questionTrendClear', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item" *ngIf="!isLongTermArea()">
              <div class="questionnaire__question">{{ questionText('questionSignalCandle') }}</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionSignalCandle')?.value === true"
                    (change)="setQuestionValue('questionSignalCandle', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionSignalCandle')?.value === false"
                    (change)="setQuestionValue('questionSignalCandle', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            <div class="questionnaire__item" *ngIf="!isLongTermArea()">
              <div class="questionnaire__question">{{ questionText('questionVolumeRising') }}</div>
              <div class="questionnaire__options">
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionVolumeRising')?.value === true"
                    (change)="setQuestionValue('questionVolumeRising', true)"
                  />
                  Ja
                </label>
                <label class="radio-option">
                  <input
                    type="checkbox"
                    [checked]="tradeForm.get('questionVolumeRising')?.value === false"
                    (change)="setQuestionValue('questionVolumeRising', false)"
                  />
                  Nein
                </label>
              </div>
            </div>
            </div>
          </section>
        </div>
        <div class="comment-screenshot">
          <div class="questionnaire__comment">
            <label>
              Kommentar
              <textarea rows="6" formControlName="comment" class="comment-input" required></textarea>
            </label>
            <div class="comment-guidance">
              <div class="comment-guidance__title">Handelsidee:</div>
              <ol>
                <li>Warum dieser Trade? Welche Annahmen liegen zugrunde?</li>
                <li>Plan: Einstieg, Stop, Ziel und wichtigste Annahme.</li>
              </ol>
            </div>
          </div>
          <div class="comment-screenshot__fields">
            <label class="screenshot-url">
              Screenshot URL
              <input type="url" placeholder="https://..." formControlName="screenshotUrl" (input)="clearScreenshotUploadMetadata()" />
            </label>
            <label class="screenshot-upload">
              Screenshot Upload
              <div
                class="analysis-dropzone"
                role="button"
                tabindex="0"
                (dragover)="onScreenshotDragOver($event)"
                (dragleave)="onScreenshotDragLeave($event)"
                (drop)="handleScreenshotDrop($event)"
                (click)="screenshotFileInput?.click()"
                (keydown.enter)="$event.preventDefault(); screenshotFileInput?.click()"
                (keydown.space)="$event.preventDefault(); screenshotFileInput?.click()"
                (paste)="handleScreenshotPaste($event)"
                [class.analysis-dropzone--active]="screenshotDropActive"
                aria-label="Bild hier ablegen, auswählen oder einfügen"
              >
                <input
                  type="file"
                  accept="image/*"
                  #screenshotFileInput
                  class="visually-hidden"
                  (change)="handleScreenshotFileSelection($event)"
                  aria-hidden="true"
                  tabindex="-1"
                />
                <div class="screenshot-dropzone__label">Bild hierher ziehen, klicken oder per Strg+V einfügen.</div>
                <div class="screenshot-dropzone__status" *ngIf="screenshotUploadName">Ausgewählt: {{ screenshotUploadName }}</div>
                <div class="screenshot-dropzone__error" *ngIf="screenshotUploadError">{{ screenshotUploadError }}</div>
              </div>
            </label>
          </div>
        </div>
        <div class="actions">
          <button class="primary" type="submit" [disabled]="isSaveDisabled()">Eintrag speichern</button>
        </div>
      </div>
    </div>
  </form>

  <div class="table" *ngIf="entries().length; else empty">
    <div class="table__title table__title--inline filters">
      <div class="table__title-line">
        <h2>Beobachtungsliste (Positioniert = Nein)</h2>
        <span class="volume-pill">Volumen: {{ plannedVolume() | number:'1.2-2' }} €</span>
      </div>
      <div class="filter-controls">
        <label>
          Anzeige
          <select [(ngModel)]="watchStatusFilter" [ngModelOptions]="{standalone: true}" (ngModelChange)="ensureWatchPageWithinBounds()">
            <option value="open">Offene</option>
            <option value="storno">Stornierte</option>
            <option value="all">Offene &amp; stornierte</option>
          </select>
        </label>
      </div>
    </div>
    <div class="table__controls">
      <div class="table__control-group">
        <label>
          Zeilen pro Seite
          <select [(ngModel)]="watchPageSize" (ngModelChange)="onWatchPageSizeChange($event)">
            <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
          </select>
        </label>
        <label class="table-toggle">
          <input type="checkbox" [(ngModel)]="showFinancialColumns" [ngModelOptions]="{standalone: true}" />
          Kennzahlen einblenden
        </label>
      </div>
      <div class="table__pagination">
        <button type="button" (click)="prevWatchPage()" [disabled]="watchCurrentPage === 1">Zurück</button>
        <span>Seite {{ watchCurrentPage }} / {{ totalPlannedPages() }}</span>
        <button type="button" (click)="nextWatchPage()" [disabled]="watchCurrentPage >= totalPlannedPages()">Weiter</button>
      </div>
    </div>
    <div class="table-scroll" role="region" aria-label="Beobachtungsliste Tabelle">
      <table class="data-table data-table--watch" [class.data-table--compact]="!showFinancialColumns">
      <colgroup>
        <col class="col-symbol" />
        <col class="col-status" />
        <col class="col-setup" />
        <col class="col-direction" />
        <col class="col-currency" *ngIf="showFinancialColumns" />
        <col class="col-date" />
        <col class="col-date" />
        <col class="col-price" />
        <col class="col-price" />
        <col class="col-price" />
        <col class="col-price" />
        <col class="col-size" />
        <col class="col-fee" *ngIf="showFinancialColumns" />
        <col class="col-fee" *ngIf="showFinancialColumns" />
        <col class="col-ratio" />
        <col class="col-pnl" *ngIf="showFinancialColumns" />
        <col class="col-comment" />
        <col class="col-screenshot" />
        <col class="col-actions" />
      </colgroup>
      <thead>
        <tr>
          <th (click)="changeWatchSort('symbol')" class="sortable" [class.sortable--active]="watchSortField === 'symbol'">
            Kürzel / WKN <span class="sort-indicator">{{ watchSortLabel('symbol') }}</span>
          </th>
          <th (click)="changeWatchSort('status')" class="sortable" [class.sortable--active]="watchSortField === 'status'">
            <span class="header-label">
              Status
              <span class="info-icon" title="Status-Kürzel: P = Positioniert, T = Teilverkauf, G = Glatt, W = Watch, S = Storniert." aria-label="Status-Kürzel anzeigen">i</span>
            </span>
            <span class="sort-indicator">{{ watchSortLabel('status') }}</span>
          </th>
          <th>
            <span class="header-label">
              Setup
              <span class="info-icon" title="Es wird nur der Anfangsbuchstabe des Setups angezeigt." aria-label="Setup-Kürzel anzeigen">i</span>
            </span>
          </th>
          <th>
            <span class="header-label">
              L/S
              <span class="info-icon" title="L = Long, S = Short." aria-label="Long/Short Erklärung">i</span>
            </span>
          </th>
          <th *ngIf="showFinancialColumns">Währung</th>
          <th (click)="changeWatchSort('entryDate')" class="sortable" [class.sortable--active]="watchSortField === 'entryDate'">
            Datum <span class="sort-indicator">{{ watchSortLabel('entryDate') }}</span>
          </th>
          <th (click)="changeWatchSort('sellDate')" class="sortable" [class.sortable--active]="watchSortField === 'sellDate'">
            Verkauf <span class="sort-indicator">{{ watchSortLabel('sellDate') }}</span>
          </th>
          <th class="numeric">VKurs</th>
          <th class="numeric">Entry</th>
          <th class="numeric">Stop</th>
          <th class="numeric">Ziel</th>
          <th class="numeric">Stk.</th>
          <th class="numeric" *ngIf="showFinancialColumns">Gebühr Kauf</th>
          <th class="numeric" *ngIf="showFinancialColumns">Gebühr Verkauf</th>
          <th class="numeric">R</th>
          <th class="numeric" *ngIf="showFinancialColumns">G&V</th>
          <th>Kommentar</th>
          <th>Screenshot</th>
          <th class="actions-header">Aktion</th>
        </tr>
      </thead>
      <tbody>
        @for (entry of displayedPlannedEntries(); track entry.id) {
        <tr [ngClass]="profitClass(entry)">
          <td data-label="Kürzel / WKN" class="text">
            <div>{{ entry.symbol }}</div>
            <div class="subtext" *ngIf="entry.wknIsin">{{ entry.wknIsin }}</div>
          </td>
          <td data-label="Status" class="text">{{ shortStatus(entry.status) }}</td>
          <td data-label="Setup" class="text">{{ shortSetup(entry.setup) }}</td>
          <td data-label="L/S" class="text">{{ shortDirection(entry.direction) }}</td>
          <td data-label="Währung" class="text" *ngIf="showFinancialColumns">{{ entry.currency || 'EUR' }}</td>
          <td data-label="Datum" class="text">{{ entry.entryDate || '-' }}</td>
          <td data-label="Verkauf" class="text">{{ entry.sellDate || '-' }}</td>
          <td data-label="VKurs" class="numeric">
            <ng-container *ngIf="averageSellPrice(entry) as avg; else noAvgWatch">
              <button
                type="button"
                class="course-link"
                [class.course-link--active]="canOpenEvaluation(entry)"
                [disabled]="!canOpenEvaluation(entry)"
                (click)="openEvaluationDialog(entry)"
              >
                {{ avg | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}
              </button>
            </ng-container>
            <ng-template #noAvgWatch>-</ng-template>
          </td>
          <td data-label="Entry" class="numeric">
            {{ entry.entryPrice | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}
          </td>
          <td data-label="Stop" class="numeric stop-cell">
            <ng-container *ngIf="stopDisplayParts(entry) as stops">
              <ng-container *ngIf="stops.previous !== undefined; else singleStopWatch">
                <span class="stop-pair">
                  <span class="stop-old">{{ stops.previous | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</span>
                  <span class="stop-new">{{ stops.current | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</span>
                </span>
              </ng-container>
              <ng-template #singleStopWatch>{{ stops.current | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</ng-template>
            </ng-container>
          </td>
          <td data-label="Ziel" class="numeric">
            <ng-container *ngIf="takeProfitDisplayParts(entry) as takeProfit">
              <span class="stop-pair" *ngIf="takeProfit.actual !== undefined; else singleTargetWatch">
                <span class="stop-old">{{ takeProfit.original | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</span>
                <span class="stop-new">{{ takeProfit.actual | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</span>
              </span>
              <ng-template #singleTargetWatch>{{ takeProfit.original | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</ng-template>
            </ng-container>
          </td>
          <td data-label="Stk." class="numeric">
            {{ entry.size }}
          </td>
          <td data-label="Gebühr Kauf" class="numeric" *ngIf="showFinancialColumns">
            {{ (entry.entryFee || 0) | number:'1.2-2' }}
          </td>
          <td data-label="Gebühr Verkauf" class="numeric" *ngIf="showFinancialColumns">{{ totalFees(entry) | number:'1.2-2' }}</td>
          <td data-label="R" class="numeric">
            <span *ngIf="hasRealizedR(entry); else noRealizedRWatch" [ngClass]="pnlClass(displayR(entry))">{{ displayR(entry) }}R</span>
            <ng-template #noRealizedRWatch>–</ng-template>
          </td>
          <td data-label="G&V" class="numeric" *ngIf="showFinancialColumns">
            <ng-container *ngIf="entry.status === 'Glatt' || entry.partialSales?.length; else noPnlWatch">
              <span [ngClass]="pnlClass(displayPnl(entry))">{{ displayPnl(entry) | number:'1.2-2' }} €</span>
            </ng-container>
            <ng-template #noPnlWatch>-</ng-template>
          </td>
          <td data-label="Kommentar" class="comment text">
            <div
              class="comment__content"
              *ngIf="hasCommentInfo(entry); else noCommentWatch"
              (mouseenter)="showCommentTooltip(entry, $event)"
              (mousemove)="moveCommentTooltip($event)"
              (mouseleave)="hideCommentTooltip()"
            >
              <div class="comment__text">{{ commentPreview(entry) }}</div>
            </div>
            <ng-template #noCommentWatch>-</ng-template>
          </td>
          <td data-label="Screenshot" class="text screenshot-list">
            <ng-container *ngIf="screenshotLines(entry).length; else noShotWatch">
              <div class="screenshot-line" *ngFor="let shot of screenshotPreviewLines(entry)">
                <span class="screenshot-line__label">{{ shot.label }}:</span>
                <a [href]="shot.url" target="_blank" rel="noopener noreferrer">
                  {{ shot.type === 'image' ? 'Bild anzeigen' : 'Link öffnen' }}
                </a>
              </div>
              <button
                *ngIf="hasMultipleScreenshots(entry)"
                type="button"
                class="screenshot-toggle"
                (click)="toggleScreenshotList(entry.id)"
                [attr.aria-expanded]="screenshotsVisible(entry.id)"
              >
                {{ screenshotsVisible(entry.id) ? '▴' : '▾' }} Alle anzeigen
              </button>
            </ng-container>
            <ng-template #noShotWatch>-</ng-template>
          </td>
          <td data-label="Aktion" class="actions-inline">
            <button
              class="primary icon"
              type="button"
              (click)="openPositionDialog(entry)"
              [disabled]="entry.status === 'Storniert'"
              aria-label="Positionieren"
              title="Positionieren"
            >
              ⇧
            </button>
            <button
              type="button"
              class="secondary icon"
              (click)="startEdit(entry)"
              [disabled]="entry.status === 'Storniert'"
              aria-label="Bearbeiten"
              title="Bearbeiten"
            >
              ✎
            </button>
            <button
              type="button"
              class="secondary icon"
              (click)="openStornoDialog(entry)"
              [disabled]="entry.status === 'Storniert'"
              aria-label="Stornieren"
              title="Stornieren"
            >
              ✖
            </button>
          </td>
        </tr>
        @if (editingEntryId === entry.id) {
          <tr class="edit-row">
            <td class="edit-cell" [attr.colspan]="tableColumnCount()">
              <div class="edit-grid">
                <label>
                  <span>Entry</span>
                  <input type="number" step="0.01" [(ngModel)]="editingValues.entryPrice" class="inline-input" />
                </label>
                <div class="stop-editor" [class.stop-editor--changed]="isStopChanged(entry)">
                  <label>
                    <span>Stop</span>
                    <input type="number" step="0.01" [(ngModel)]="editingValues.stopPrice" class="inline-input" />
                  </label>
                  <div class="stop-editor__reason" *ngIf="isStopChanged(entry)">
                    <strong>Warum will ich den Stop verändern? Begründe ihn genau oder lasse den Finger vom Stop!</strong>
                    <textarea rows="2" [(ngModel)]="editingValues.stopChangeReason" class="inline-input"></textarea>
                  </div>
                </div>
                <label>
                  <span>Ursprüngliches Ziel</span>
                  <input type="number" step="0.01" [(ngModel)]="editingValues.targetPrice" class="inline-input" readonly />
                </label>
                <label>
                  <span>Stk.</span>
                  <input type="number" step="1" [(ngModel)]="editingValues.size" class="inline-input" />
                </label>
                <label class="edit-comment">
                  <span>Kommentar</span>
                  <textarea rows="3" [(ngModel)]="editingValues.comment" class="inline-input"></textarea>
                  <div class="edit-comment__links" *ngIf="commentLinks(editingValues.comment).length">
                    <a *ngFor="let url of commentLinks(editingValues.comment)" [href]="url" target="_blank" rel="noopener noreferrer">
                      Link öffnen
                    </a>
                  </div>
                </label>
                <div class="edit-actions">
                  <button type="button" class="primary icon icon--pill" (click)="saveEdit(entry.id)" aria-label="Übernehmen" title="Übernehmen">✔</button>
                  <button type="button" class="neutral icon icon--pill" (click)="cancelEdit()" aria-label="Abbrechen" title="Abbrechen">✖</button>
                </div>
              </div>
            </td>
          </tr>
        }
        }
      </tbody>
      </table>
    </div>
    <div class="table-divider" aria-hidden="true"></div>

    <div class="table__title table__title--inline filters">
      <div>
        <div class="table__title-line">
          <h2>Positioniert (Positioniert = Ja)</h2>
          <span class="volume-pill">Volumen: {{ openPositionVolume() | number:'1.2-2' }} €</span>
        </div>
        <p>Auf Basis der Chance und Gewinnschwelle siehst du hier die nötigen Trades.</p>
        <div class="pill-row">
          <span class="pnl-pill" [ngClass]="{ 'pnl-pill--positive': positionedRealizedRSum() > 0, 'pnl-pill--negative': positionedRealizedRSum() < 0 }">
            Σ G&V: {{ positionedRealizedRSum() | number:'1.2-2' }}R
          </span>
          <span class="risk-pill">Max Risiko: {{ maxRiskOpen() | number:'1.2-2' }} €</span>
        </div>
      </div>
      <div class="filter-controls">
        <label>
          Jahr
          <select [(ngModel)]="yearFilter" [ngModelOptions]="{standalone: true}" (ngModelChange)="ensurePageWithinBounds()">
            <option *ngFor="let year of yearFilterOptions" [value]="year">{{ year || 'Alle' }}</option>
          </select>
        </label>
        <label>
          Status
          <select [(ngModel)]="positionedStatusFilter" [ngModelOptions]="{standalone: true}" (ngModelChange)="ensurePageWithinBounds()">
            <option value="">Alle</option>
            <option value="Positioniert">Positioniert</option>
            <option value="Teilverkauf">Teilverkauf</option>
            <option value="Glatt">Glatt</option>
          </select>
        </label>
        <label>
          Von
          <input type="date" [(ngModel)]="dateFrom" [ngModelOptions]="{standalone: true}" (change)="ensurePageWithinBounds()" />
        </label>
        <label>
          Bis
          <input type="date" [(ngModel)]="dateTo" [ngModelOptions]="{standalone: true}" (change)="ensurePageWithinBounds()" />
        </label>
      </div>
    </div>
    <div class="table__controls">
      <div class="table__control-group">
        <label>
          Zeilen pro Seite
          <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
            <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
          </select>
        </label>
        <label class="table-toggle">
          <input type="checkbox" [(ngModel)]="showFinancialColumns" [ngModelOptions]="{standalone: true}" />
          Kennzahlen einblenden
        </label>
      </div>
      <div class="table__pagination">
        <button type="button" (click)="prevPage()" [disabled]="currentPage === 1">Zurück</button>
        <span>Seite {{ currentPage }} / {{ totalPositionedPages() }}</span>
        <button type="button" (click)="nextPage()" [disabled]="currentPage >= totalPositionedPages()">Weiter</button>
      </div>
    </div>
    <div class="table-scroll" role="region" aria-label="Positioniert Tabelle">
      <table class="data-table data-table--positioned" [class.data-table--compact]="!showFinancialColumns">
      <colgroup>
        <col class="col-symbol" />
        <col class="col-status" />
        <col class="col-setup" />
        <col class="col-direction" />
        <col class="col-currency" *ngIf="showFinancialColumns" />
        <col class="col-date" />
        <col class="col-date" />
        <col class="col-price" />
        <col class="col-price" />
        <col class="col-price" />
        <col class="col-price" />
        <col class="col-size" />
        <col class="col-fee" *ngIf="showFinancialColumns" />
        <col class="col-fee" *ngIf="showFinancialColumns" />
        <col class="col-ratio" />
        <col class="col-pnl" *ngIf="showFinancialColumns" />
        <col class="col-comment" />
        <col class="col-screenshot" />
        <col class="col-actions" />
      </colgroup>
      <thead>
        <tr>
          <th (click)="changeSort('symbol')" class="sortable" [class.sortable--active]="sortField === 'symbol'">
            Kürzel / WKN <span class="sort-indicator">{{ sortLabel('symbol') }}</span>
          </th>
          <th (click)="changeSort('status')" class="sortable" [class.sortable--active]="sortField === 'status'">
            <span class="header-label">
              Status
              <span class="info-icon" title="Status-Kürzel: P = Positioniert, T = Teilverkauf, G = Glatt, W = Watch, S = Storniert." aria-label="Status-Kürzel anzeigen">i</span>
            </span>
            <span class="sort-indicator">{{ sortLabel('status') }}</span>
          </th>
          <th>
            <span class="header-label">
              Setup
              <span class="info-icon" title="Es wird nur der Anfangsbuchstabe des Setups angezeigt." aria-label="Setup-Kürzel anzeigen">i</span>
            </span>
          </th>
          <th>
            <span class="header-label">
              L/S
              <span class="info-icon" title="L = Long, S = Short." aria-label="Long/Short Erklärung">i</span>
            </span>
          </th>
          <th *ngIf="showFinancialColumns">Währung</th>
          <th (click)="changeSort('entryDate')" class="sortable" [class.sortable--active]="sortField === 'entryDate'">
            Datum <span class="sort-indicator">{{ sortLabel('entryDate') }}</span>
          </th>
          <th (click)="changeSort('sellDate')" class="sortable" [class.sortable--active]="sortField === 'sellDate'">
            Verkauf <span class="sort-indicator">{{ sortLabel('sellDate') }}</span>
          </th>
          <th class="numeric">VKurs</th>
          <th class="numeric">Entry</th>
          <th class="numeric">Stop</th>
          <th class="numeric">Ziel</th>
          <th class="numeric">Stk.</th>
          <th class="numeric" *ngIf="showFinancialColumns">Gebühr Kauf</th>
          <th class="numeric" *ngIf="showFinancialColumns">Gebühr Verkauf</th>
          <th class="numeric">R</th>
          <th class="numeric" *ngIf="showFinancialColumns">G&V</th>
          <th>Kommentar</th>
          <th>Screenshot</th>
          <th class="actions-header">Aktion</th>
        </tr>
      </thead>
      <tbody>
        @for (entry of displayedPositionedEntries(); track entry.id) {
        <tr [ngClass]="[profitClass(entry), activePositionClass(entry)]">
          <td data-label="Kürzel / WKN" class="text">
            <div>{{ entry.symbol }}</div>
            <div class="subtext" *ngIf="entry.wknIsin">{{ entry.wknIsin }}</div>
          </td>
          <td data-label="Status" class="text">{{ shortStatus(entry.status) }}</td>
          <td data-label="Setup" class="text">{{ shortSetup(entry.setup) }}</td>
          <td data-label="L/S" class="text">{{ shortDirection(entry.direction) }}</td>
          <td data-label="Währung" class="text" *ngIf="showFinancialColumns">{{ entry.currency || 'EUR' }}</td>
          <td data-label="Datum" class="text">{{ entry.entryDate }}</td>
          <td data-label="Verkauf" class="text">{{ entry.sellDate || '-' }}</td>
          <td data-label="VKurs" class="numeric">
            <ng-container *ngIf="averageSellPrice(entry) as avg; else noAvgPosition">
              <button
                type="button"
                class="course-link"
                [class.course-link--active]="canOpenEvaluation(entry)"
                [disabled]="!canOpenEvaluation(entry)"
                (click)="openEvaluationDialog(entry)"
              >
                {{ avg | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}
              </button>
            </ng-container>
            <ng-template #noAvgPosition>-</ng-template>
          </td>
          <td data-label="Entry" class="numeric">
            {{ entry.entryPrice | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}
          </td>
          <td data-label="Stop" class="numeric stop-cell">
            <ng-container *ngIf="stopDisplayParts(entry) as stops">
              <ng-container *ngIf="stops.previous !== undefined; else singleStopPos">
                <span class="stop-pair">
                  <span class="stop-old">{{ stops.previous | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</span>
                  <span class="stop-new">{{ stops.current | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</span>
                </span>
              </ng-container>
              <ng-template #singleStopPos>{{ stops.current | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</ng-template>
            </ng-container>
          </td>
          <td data-label="Ziel" class="numeric">
            <ng-container *ngIf="takeProfitDisplayParts(entry) as takeProfit">
              <span class="stop-pair" *ngIf="takeProfit.actual !== undefined; else singleTargetPos">
                <span class="stop-old">{{ takeProfit.original | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</span>
                <span class="stop-new">{{ takeProfit.actual | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</span>
              </span>
              <ng-template #singleTargetPos>{{ takeProfit.original | number:'1.2-2' }} {{ currencySymbol(entry.currency) }}</ng-template>
            </ng-container>
          </td>
          <td data-label="Stk." class="numeric">
            {{ entry.size }}
          </td>
          <td data-label="Gebühr Kauf" class="numeric" *ngIf="showFinancialColumns">
            {{ (entry.entryFee || 0) | number:'1.2-2' }}
          </td>
          <td data-label="Gebühr Verkauf" class="numeric" *ngIf="showFinancialColumns">{{ totalFees(entry) | number:'1.2-2' }}</td>
          <td data-label="R" class="numeric">
            <span *ngIf="hasRealizedR(entry); else noRealizedRPosition" [ngClass]="pnlClass(displayR(entry))">{{ displayR(entry) }}R</span>
            <ng-template #noRealizedRPosition>–</ng-template>
          </td>
          <td data-label="G&V" class="numeric" *ngIf="showFinancialColumns">
            <ng-container *ngIf="entry.status === 'Glatt' || entry.partialSales?.length; else noPnl">
              <span [ngClass]="pnlClass(displayPnl(entry))">{{ displayPnl(entry) | number:'1.2-2' }} €</span>
            </ng-container>
            <ng-template #noPnl>-</ng-template>
          </td>
          <td data-label="Kommentar" class="comment text">
            <div
              class="comment__content"
              *ngIf="hasCommentInfo(entry); else noCommentPos"
              (mouseenter)="showCommentTooltip(entry, $event)"
              (mousemove)="moveCommentTooltip($event)"
              (mouseleave)="hideCommentTooltip()"
            >
              <div class="comment__text">{{ commentPreview(entry) }}</div>
            </div>
            <ng-template #noCommentPos>-</ng-template>
          </td>
          <td data-label="Screenshot" class="text screenshot-list">
            <ng-container *ngIf="screenshotLines(entry).length; else noShotPos">
              <div class="screenshot-line" *ngFor="let shot of screenshotPreviewLines(entry)">
                <span class="screenshot-line__label">{{ shot.label }}:</span>
                <a [href]="shot.url" target="_blank" rel="noopener noreferrer">
                  {{ shot.type === 'image' ? 'Bild anzeigen' : 'Link öffnen' }}
                </a>
              </div>
              <button
                *ngIf="hasMultipleScreenshots(entry)"
                type="button"
                class="screenshot-toggle"
                (click)="toggleScreenshotList(entry.id)"
                [attr.aria-expanded]="screenshotsVisible(entry.id)"
              >
                {{ screenshotsVisible(entry.id) ? '▴' : '▾' }} Alle anzeigen
              </button>
            </ng-container>
            <ng-template #noShotPos>-</ng-template>
          </td>
          <td data-label="Aktion" class="actions-inline">
            <button
              type="button"
              class="primary icon"
              (click)="setFlat(entry.id)"
              [disabled]="entry.status === 'Glatt'"
              aria-label="Glatt stellen"
              title="Glatt stellen"
            >
              ⇩
            </button>
            <button
              type="button"
              class="secondary icon"
              (click)="openDailyCheck(entry)"
              [disabled]="entry.status !== 'Positioniert'"
              aria-label="Täglicher Check"
              title="Täglicher Check"
            >
              🗓
            </button>
            <button
              type="button"
              class="secondary icon"
              (click)="startEdit(entry)"
              aria-label="Bearbeiten"
              title="Bearbeiten"
            >
              ✎
            </button>
            <button
              type="button"
              class="secondary icon"
              (click)="togglePartialList(entry.id)"
              [disabled]="!entry.partialSales?.length"
              aria-label="Teil-Verkäufe anzeigen"
              title="Teil-Verkäufe anzeigen"
            >
              {{ partialsVisible(entry.id) ? '▾' : '▸' }}
            </button>
          </td>
        </tr>
        @if (editingEntryId === entry.id) {
          <tr class="edit-row">
            <td class="edit-cell" [attr.colspan]="tableColumnCount()">
              <div class="edit-grid">
                <label>
                  <span>Entry</span>
                  <input type="number" step="0.01" [(ngModel)]="editingValues.entryPrice" class="inline-input" />
                </label>
                <div class="stop-editor" [class.stop-editor--changed]="isStopChanged(entry)">
                  <label>
                    <span>Stop</span>
                    <input type="number" step="0.01" [(ngModel)]="editingValues.stopPrice" class="inline-input" />
                  </label>
                  <div class="stop-editor__reason" *ngIf="isStopChanged(entry)">
                    <strong>Warum will ich den Stop verändern? Begründe ihn genau oder lasse den Finger vom Stop!</strong>
                    <textarea rows="2" [(ngModel)]="editingValues.stopChangeReason" class="inline-input"></textarea>
                  </div>
                </div>
                <label>
                  <span>Ursprüngliches Ziel</span>
                  <input type="number" step="0.01" [(ngModel)]="editingValues.targetPrice" class="inline-input" readonly />
                </label>
                <label>
                  <span>Stk.</span>
                  <input type="number" step="1" [(ngModel)]="editingValues.size" class="inline-input" />
                </label>
                <label class="edit-comment">
                  <span>Kommentar</span>
                  <textarea rows="3" [(ngModel)]="editingValues.comment" class="inline-input"></textarea>
                  <div class="edit-comment__links" *ngIf="commentLinks(editingValues.comment).length">
                    <a *ngFor="let url of commentLinks(editingValues.comment)" [href]="url" target="_blank" rel="noopener noreferrer">
                      Link öffnen
                    </a>
                  </div>
                </label>
                <div class="edit-actions">
                  <button type="button" class="primary icon icon--pill" (click)="saveEdit(entry.id)" aria-label="Übernehmen" title="Übernehmen">✔</button>
                  <button type="button" class="neutral icon icon--pill" (click)="cancelEdit()" aria-label="Abbrechen" title="Abbrechen">✖</button>
                </div>
              </div>
            </td>
          </tr>
        }
        @if (entry.partialSales?.length && partialsVisible(entry.id)) {
          <tr class="partial-row">
            <td class="partial-cell" [attr.colspan]="tableColumnCount()">
              <div class="partial-row__summary text">{{ partialSummary(entry) }}</div>
              <div class="partial-row__content">
                <div class="partial-row__item" *ngFor="let sale of entry.partialSales">
                  <div class="text">{{ sale.date }}</div>
                  <div class="numeric">{{ sale.size }} Stk</div>
                  <div class="numeric">{{ sale.price | number:'1.2-2' }} €</div>
                  <div class="numeric">Gebühr: {{ (sale.fee || 0) | number:'1.2-2' }} €</div>
                  <div class="numeric" *ngIf="showFinancialColumns" [ngClass]="{ 'row-profit': sale.pnl > 0, 'row-loss': sale.pnl < 0 }">{{ displayPartialPnl(entry, sale.pnl) | number:'1.2-2' }} €</div>
                  <div class="text" *ngIf="sale.comment">{{ sale.comment }}</div>
                </div>
                <div class="partial-row__total text" *ngIf="showFinancialColumns">
                  Summe G&V: <span [ngClass]="{ 'row-profit': displayPartialPnlSum(entry) > 0, 'row-loss': displayPartialPnlSum(entry) < 0 }">{{ displayPartialPnlSum(entry) | number:'1.2-2' }} €</span>
                </div>
              </div>
            </td>
          </tr>
        }
        }
      </tbody>
      </table>
    </div>
  </div>

  <div class="sell-modal" *ngIf="sellEntry && sellDialogMode === 'sell'">
    <form [formGroup]="sellForm" (ngSubmit)="submitSellDetails()" class="sell-modal__content">
      <div class="sell-modal__header">Verkauf erfassen: {{ sellEntry.symbol }}</div>
      <div class="sell-modal__grid">
        <label>
          Verkaufskurs
          <input type="number" formControlName="sellPrice" step="0.01" />
        </label>
        <label>
          Verkaufte Stückzahl
          <input type="number" formControlName="sellSize" step="1" />
        </label>
        <label>
          Verkaufsdatum
          <input type="date" formControlName="sellDate" />
        </label>
        <label>
          Gebühren (Verkauf, €)
          <input type="number" formControlName="sellFee" step="0.01" min="0" />
        </label>
        <label>
          Verkaufs-Screenshot URL
          <input type="url" formControlName="sellScreenshotUrl" placeholder="https://" />
        </label>
        <div class="sell-modal__question">
          <div class="sell-modal__question-label">Habe ich alle Regeln eingehalten?</div>
          <div class="questionnaire__options">
            <label class="radio-option">
              <input
                type="checkbox"
                [checked]="sellForm.get('rulesFollowed')?.value === true"
                (change)="onRulesFollowedChange(true)"
              />
              Ja
            </label>
            <label class="radio-option">
              <input
                type="checkbox"
                [checked]="sellForm.get('rulesFollowed')?.value === false"
                (change)="onRulesFollowedChange(false)"
              />
              Nein
            </label>
          </div>
        </div>
        <label class="sell-modal__comment">
          Kommentar aktualisieren
          <textarea formControlName="sellComment" rows="2"></textarea>
          <div class="comment-guidance">
            <ol>
              <li>Erfolgsanalyse: Hat der Trade funktioniert? Warum/warum nicht?</li>
              <li>Abweichungen: Bin ich vom ursprünglichen Plan abgewichen?</li>
              <li>Lernpunkte: Was nehme ich aus dem Trade mit? Wie kann ich mich verbessern?</li>
            </ol>
          </div>
        </label>
      </div>
      <div class="sell-modal__actions">
        <button type="submit" class="primary icon">✔</button>
        <button type="button" class="neutral icon" (click)="closeSellDialog()">✖</button>
      </div>
    </form>
  </div>

  <div class="sell-modal" *ngIf="stornoEntryForDialog as entry">
    <form (ngSubmit)="submitStornoDetails()" class="sell-modal__content">
      <div class="sell-modal__header">Storno erfassen: {{ entry.symbol }}</div>
      <div class="sell-modal__grid">
        <label>
          Storno-Link
          <input
            type="url"
            name="stornoScreenshotUrl"
            [(ngModel)]="stornoScreenshotUrl"
            [ngModelOptions]="{standalone: true}"
            placeholder="https://"
            (input)="clearStornoScreenshotUploadMetadata()"
          />
        </label>
        <label class="screenshot-upload">
          Storno-Bild
          <div
            class="analysis-dropzone"
            role="button"
            tabindex="0"
            (dragover)="onStornoScreenshotDragOver($event)"
            (dragleave)="onStornoScreenshotDragLeave($event)"
            (drop)="handleStornoScreenshotDrop($event)"
            (click)="stornoScreenshotFileInput?.click()"
            (keydown.enter)="$event.preventDefault(); stornoScreenshotFileInput?.click()"
            (keydown.space)="$event.preventDefault(); stornoScreenshotFileInput?.click()"
            (paste)="handleStornoScreenshotPaste($event)"
            [class.analysis-dropzone--active]="stornoScreenshotDropActive"
            aria-label="Storno-Bild hier ablegen, auswählen oder einfügen"
          >
            <input
              type="file"
              accept="image/*"
              #stornoScreenshotFileInput
              class="visually-hidden"
              (change)="handleStornoScreenshotFileSelection($event)"
              aria-hidden="true"
              tabindex="-1"
            />
            <div class="screenshot-dropzone__label">Bild hierher ziehen, klicken oder per Strg+V einfügen.</div>
            <div class="screenshot-dropzone__status" *ngIf="stornoScreenshotUploadName">Ausgewählt: {{ stornoScreenshotUploadName }}</div>
            <div class="screenshot-dropzone__error" *ngIf="stornoScreenshotUploadError">{{ stornoScreenshotUploadError }}</div>
          </div>
        </label>
        <div class="sell-modal__comment storno-modal__hint">
          Der Eintrag wird auf Storniert gesetzt. Link oder Bild werden in der Screenshot-Spalte als Storno-Nachweis angezeigt.
        </div>
      </div>
      <div class="sell-modal__actions">
        <button type="submit" class="primary icon">✔</button>
        <button type="button" class="neutral icon" (click)="closeStornoDialog()">✖</button>
      </div>
    </form>
  </div>

  <div class="sell-modal" *ngIf="dailyCheckEntryId">
    <form [formGroup]="dailyCheckForm" (ngSubmit)="submitDailyCheck()" class="sell-modal__content">
      <div class="sell-modal__header">Täglicher Check</div>
      <div class="sell-modal__question">
        <div class="sell-modal__question-label">Ist die Struktur noch intakt?</div>
        <div class="questionnaire__options">
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('structureIntact')?.value === true"
              (change)="onDailyCheckChange('structureIntact', true)"
            />
            Ja
          </label>
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('structureIntact')?.value === false"
              (change)="onDailyCheckChange('structureIntact', false)"
            />
            Nein
          </label>
        </div>
      </div>
      <div class="sell-modal__question">
        <div class="sell-modal__question-label">Wurde meine Annahme verletzt?</div>
        <div class="questionnaire__options">
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('assumptionViolated')?.value === true"
              (change)="onDailyCheckChange('assumptionViolated', true)"
            />
            Ja
          </label>
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('assumptionViolated')?.value === false"
              (change)="onDailyCheckChange('assumptionViolated', false)"
            />
            Nein
          </label>
        </div>
      </div>
      <div class="sell-modal__question">
        <div class="sell-modal__question-label">Ist der Stop/Loss noch richtig?</div>
        <div class="questionnaire__options">
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('stopCorrect')?.value === true"
              (change)="onDailyCheckChange('stopCorrect', true)"
            />
            Ja
          </label>
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('stopCorrect')?.value === false"
              (change)="onDailyCheckChange('stopCorrect', false)"
            />
            Nein
          </label>
        </div>
      </div>
      <div class="sell-modal__question">
        <div class="sell-modal__question-label">Stehen Earnings kurzfristig an?</div>
        <div class="questionnaire__options">
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('earningsSoon')?.value === true"
              (change)="onDailyCheckChange('earningsSoon', true)"
            />
            Ja
          </label>
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('earningsSoon')?.value === false"
              (change)="onDailyCheckChange('earningsSoon', false)"
            />
            Nein
          </label>
        </div>
      </div>
      <div class="sell-modal__question">
        <div class="sell-modal__question-label">Habe ich alle Regeln eingehalten?</div>
        <div class="questionnaire__options">
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('rulesFollowed')?.value === true"
              (change)="onDailyCheckChange('rulesFollowed', true)"
            />
            Ja
          </label>
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('rulesFollowed')?.value === false"
              (change)="onDailyCheckChange('rulesFollowed', false)"
            />
            Nein
          </label>
        </div>
      </div>
      <div class="sell-modal__question" *ngIf="isDailyCheckLongTerm()">
        <div class="sell-modal__question-label">Trend weiterhin intakt?</div>
        <div class="questionnaire__options">
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('longTermTrendIntact')?.value === true"
              (change)="onDailyCheckChange('longTermTrendIntact', true)"
            />
            Ja
          </label>
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('longTermTrendIntact')?.value === false"
              (change)="onDailyCheckChange('longTermTrendIntact', false)"
            />
            Nein
          </label>
        </div>
      </div>
      <div class="sell-modal__question" *ngIf="isDailyCheckLongTerm()">
        <div class="sell-modal__question-label">RSI überkauft oder überverkauft?</div>
        <div class="questionnaire__options">
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('longTermRsiExtreme')?.value === true"
              (change)="onDailyCheckChange('longTermRsiExtreme', true)"
            />
            Ja
          </label>
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('longTermRsiExtreme')?.value === false"
              (change)="onDailyCheckChange('longTermRsiExtreme', false)"
            />
            Nein
          </label>
        </div>
      </div>
      <div class="sell-modal__question" *ngIf="isDailyCheckLongTerm() && dailyCheckForm.get('longTermRsiExtreme')?.value === true">
        <div class="sell-modal__question-label">Ist der Stop/Loss noch richtig?</div>
        <div class="questionnaire__options">
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('longTermStopCorrect')?.value === true"
              (change)="onDailyCheckChange('longTermStopCorrect', true)"
            />
            Ja
          </label>
          <label class="radio-option">
            <input
              type="checkbox"
              [checked]="dailyCheckForm.get('longTermStopCorrect')?.value === false"
              (change)="onDailyCheckChange('longTermStopCorrect', false)"
            />
            Nein
          </label>
        </div>
      </div>
      <label class="sell-modal__comment">
        Kommentar
        <textarea formControlName="comment" rows="9" (input)="onDailyCheckCommentInput()"></textarea>
      </label>
      <div class="sell-modal__actions">
        <button type="submit" class="primary icon">✔</button>
        <button type="button" class="neutral icon" (click)="closeDailyCheck()">✖</button>
      </div>
    </form>
  </div>

  <ng-template #empty>
    <div class="empty">Noch keine Trades erfasst.</div>
  </ng-template>

  <div class="sell-modal" *ngIf="sellDialogEntryId && sellEntry && positionForm && sellDialogMode === 'position'">
    <form [formGroup]="positionForm" (ngSubmit)="confirmPositionDialog()" class="sell-modal__content">
      <div class="sell-modal__header">Positionieren: {{ sellEntry.symbol }}</div>
      <div class="sell-modal__grid">
        <label>
          Entry
          <input type="number" formControlName="entryPrice" step="0.01" />
        </label>
        <label>
          Datum
          <input type="date" formControlName="entryDate" />
        </label>
        <label class="sell-modal__comment">
          Kommentar
          <textarea formControlName="comment" rows="2"></textarea>
          <div class="comment-guidance">
            <ol>
              <li>Emotionen & Verhalten: Wie fühle ich mich? Bin ich abgelenkt? Halte ich mich an den Plan?</li>
              <li>Marktdaten: Volatilität, unerwartete Nachrichten.</li>
            </ol>
          </div>
        </label>
      </div>
      <div class="sell-modal__actions">
        <button type="submit" class="primary icon" [disabled]="positionForm.invalid">✔</button>
        <button type="button" class="neutral icon" (click)="closePositionDialog()">✖</button>
      </div>
    </form>
  </div>
</section>
